import { BaseDto } from '@/shared/dtos/base-dto';

export class form_item extends BaseDto {
    public caption !: string;
    public variableName !: string;
    public datatype !: string;
    public visible !: boolean;
    public maxLength !: number;
    public intab !: number;
    public estado !: boolean;
    public orden !: number;
    public id_dinamically_form !: number;
 } 
